import { isMobile } from "@modules/util/device"

if (!isMobile()) {
    const userNavElement = $("#user-nav")

    userNavElement.on(
        "mouseenter focusin mouseleave focusout",
        /**
         * @param {Event} focusEvent
         */
        function (this: typeof userNavElement, focusEvent: FocusEvent) {
            const targetElement = $(focusEvent.currentTarget)
            const popupTargetElementId = $(focusEvent.currentTarget).data("target")
            const popupTargetElement = $(popupTargetElementId)

            if (!targetElement.length) {
                return
            }

            if (null !== this.popupCloseTimerId) {
                // Schließen unterbinden, wenn die Maus schnell genug
                // 	wieder in den Bereich navigiert wird
                window.clearTimeout(this.popupCloseTimerId)
                this.popupCloseTimerId = null
            }

            switch (focusEvent.type) {
                case "mouseenter":
                case "focusin":
                    targetElement.removeClass("collapsed")
                    popupTargetElement.removeClass("hide")
                    break

                default:
                    // Etwas Delay beim Schließen, falls man mal kurz aus
                    // 	versehen das Element verlässt
                    this.popupCloseTimerId = window.setTimeout(() => {
                        targetElement.addClass("collapsed")
                        popupTargetElement.addClass("hide")
                    }, this.popupCloseDelayMS)
                    break
            }
        },
    )
}
